import { Text } from '@thanx/uikit/text'
import ModalContainer from 'components/ModalContainer'
import { buildTranslate } from 'locales'

const t = buildTranslate('merchant_users.new_domain_warning')

const DATA_SHARING_DOCS_URL = 'https://docs.thanx.com/data/overview'

type Props = {
  isOpen: boolean
  isLoading?: boolean
  onClose: () => void
  onProceed: () => void
}

const NewDomainWarningModal = ({
  isOpen,
  isLoading = false,
  onClose,
  onProceed,
}: Props) => {
  return (
    <ModalContainer
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      onProceed={onProceed}
      title={t('title')}
      proceedText={t('proceed')}
    >
      <div className="mt-xl">
        <Text.BodyText2 tag="div">
          <span
            dangerouslySetInnerHTML={{
              __html: t('body', { url: DATA_SHARING_DOCS_URL }),
            }}
          />
        </Text.BodyText2>
        <Text.BodyText2 tag="div" className="mt-s">
          {t('confirmation')}
        </Text.BodyText2>
      </div>
    </ModalContainer>
  )
}

export default NewDomainWarningModal
